import "./style.scss";

import ModalBox from "components/Modal";
import StyledButton from "components/shared/StyledButton";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { H3 } from "helpers/TypographyComponents";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { createTermGroup } from "store/beneficiaryStore";
import { postChannelCompensationGroups } from "store/channelStore";
import { useAppDispatch } from "store/store";
import { createTitleGroup } from "store/titleStore";

interface GroupModal {
    openModal: boolean;
    onClose: () => void;
    type: "title" | "channel" | "term";
    setNewGroupId?: any;
    elementId?: number;
}

const NewGroupModal = ({ openModal, onClose, type, setNewGroupId, elementId }: GroupModal) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const [newCompGroupName, setNewCompGroupName] = useState("");

    const onAddCompensationGroup = () => {
        if (newCompGroupName.length == 0) return;

        if (type === "channel") {
            dispatch(postChannelCompensationGroups({ name: newCompGroupName })).then((resp: any) => {
                if (resp.payload?.id === undefined) return;
                setNewCompGroupName("");
                setNewGroupId(resp.payload.id);
                onClose();
            });
        } else if (type === "title") {
            dispatch(createTitleGroup({ name: newCompGroupName })).then((resp: any) => {
                if (resp.payload?.id === undefined) return;
                setNewCompGroupName("");
                setNewGroupId(resp.payload.id);
                onClose();
            });
        } else {
            elementId &&
                dispatch(createTermGroup({ beneficiaryId: elementId, name: newCompGroupName })).then((resp: any) => {
                    if (resp.payload?.id === undefined) return;
                    setNewCompGroupName("");
                    setNewGroupId(resp.payload.id);
                    onClose();
                });
        }
    };

    return (
        <ModalBox open={openModal} onClose={onClose} mainTitle={t("NewChannel.AddCompensationGroup")}>
            <div className="add-compensation-channel-modal">
                <div className="add-compensation-field">
                    <H3>{t("NewChannel.GroupName")}</H3>
                    <StyledTextField
                        value={newCompGroupName}
                        onChange={(e: any) => setNewCompGroupName(e.target.value)}
                        autoFocus
                        fullWidth
                        placeholder={t("NewChannel.GroupPlaceholder")}
                    />
                </div>
                <StyledButton buttonType="primary" onClick={onAddCompensationGroup}>
                    {t("NewChannel.CreateGroup")}
                </StyledButton>
            </div>
        </ModalBox>
    );
};

export default NewGroupModal;
